/* ============================================================
   §5 Pilatix App — Exercises (marquee carousel)
   1:1 port of _fitness-demo/js/main.js setupExercises().

   - Clones the 12 original slides once at init so the strip holds 24.
     CSS animates translateX 0 → -50% over the configured duration,
     which lands exactly on the first clone (= identical to slide 0),
     producing an invisible loop.
   - Marquee runs only while the carousel is on screen + tab is visible.
   - Polls (setInterval 120ms) which slide is closest to viewport center
     and cross-fades the label below. setInterval not rAF because the
     check is cheap and consistent regardless of paint throttling.

   Per-section scoping (multiple instances OK).
   ============================================================ */
(function () {
  'use strict';

  function setup(root) {
    if (!root || root.__pltx2FxSetup) return;
    root.__pltx2FxSetup = true;

    var track    = root.querySelector('[data-fx-track]');
    var viewport = root.querySelector('.pltx2-fexercises__viewport');
    var nameEl   = root.querySelector('[data-fx-name]');
    if (!track) return;

    var originalSlides = Array.prototype.slice.call(track.querySelectorAll('.pltx2-fexercises__slide'));
    if (!originalSlides.length) return;

    // Clone each slide once — same DOM, marked as clone for aria
    originalSlides.forEach(function (s) {
      var clone = s.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('is-clone');
      track.appendChild(clone);
    });
    var allSlides = Array.prototype.slice.call(track.querySelectorAll('.pltx2-fexercises__slide'));

    function run()  { root.classList.add('is-running'); }
    function halt() { root.classList.remove('is-running'); }

    document.addEventListener('visibilitychange', function () {
      document.hidden ? halt() : run();
    });

    // Center detection — fades nameEl on change
    var lastOrigIdx = -1;
    function updateCenter() {
      if (!viewport || !nameEl) return;
      var vRect = viewport.getBoundingClientRect();
      if (vRect.width === 0) return;
      var centerX = vRect.left + vRect.width / 2;
      var bestIdx = 0, bestDist = Infinity;
      for (var i = 0; i < allSlides.length; i++) {
        var r = allSlides[i].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - centerX);
        if (d < bestDist) { bestDist = d; bestIdx = i; }
      }
      var origIdx = bestIdx % originalSlides.length;
      if (origIdx !== lastOrigIdx) {
        lastOrigIdx = origIdx;
        var newName = allSlides[bestIdx].getAttribute('data-name') || '';
        nameEl.classList.add('is-fading');
        setTimeout(function () {
          nameEl.textContent = newName;
          nameEl.classList.remove('is-fading');
        }, 180);
      }
    }
    var centerInterval = null;
    function startCenter() {
      if (!centerInterval) centerInterval = setInterval(updateCenter, 120);
    }
    function stopCenter() {
      if (centerInterval) { clearInterval(centerInterval); centerInterval = null; }
    }

    // Tie marquee + polling to viewport visibility
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { run();  startCenter(); }
          else                  { halt(); stopCenter();  }
        });
      }, { threshold: 0.1 });
      io.observe(root);
    } else {
      run(); startCenter();
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-fx-carousel]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('[data-fx-carousel]')
      : null;
    if (root) setup(root);
  });
})();
